'use client';

import { AnimatePresence } from 'framer-motion';
import { SignIn } from '@/components/Auth/SignIn';

const ERROR_COPY = {
  'exchange-failed': "We couldn't finish signing you in. Please try again.",
} as const;

export default function LoginForm({
  callbackUrl,
  error,
}: {
  callbackUrl?: string;
  error?: keyof typeof ERROR_COPY;
}) {
  return (
    <div className="h-screen bg-ds-brand-darker p-[20px] flex items-stretch">
      <AnimatePresence mode="wait">
        <SignIn
          key="signin"
          callbackUrl={callbackUrl}
          notice={
            error ? (
              <p
                role="alert"
                className="font-instrument-sans text-sm font-medium text-ds-danger-default text-center"
              >
                {ERROR_COPY[error]}
              </p>
            ) : undefined
          }
        />
      </AnimatePresence>
    </div>
  );
}
